import React, { useEffect, useState } from 'react';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { propTypes } from '../../util/types';
import data from './data.json';
import css from './CusstonTermsOfServicePage.module.css';
import StaticPage from '../PageBuilder/StaticPage';
import { LayoutComposer } from '../PageBuilder/PageBuilder';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterComponent from '../FooterContainer/FooterContainer';
import TopbarSearchForm from '../../components/Topbar/TopbarSearchForm/TopbarSearchForm';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';

import { H2 } from '../../components';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import CookieMananger from '../../components/ui-components/cookies/CookieMananger';
import AccordionContainers from '../../components/Accordion/AccordionContainer';
import SmallBlackColorText from '../../components/text/SmallBlackColorText';
import { useParams } from 'react-router-dom';

export const CusstonTermsOfServicePage = props => {
  const [showNav, setShowNav] = useState(typeof window !== 'undefined' && !(window.scrollY == 0));

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const maxScroll = 18; // Ajusta esta cantidad según tu preferencia
      const shouldShowNav = scrollTop > maxScroll;

      setShowNav(shouldShowNav);
    };

    if (!window.scrollEventListener) {
      window.addEventListener('scroll', handleScroll);
      window.scrollEventListener = handleScroll;
    }

    return () => {
      if (window.scrollEventListener) {
        window.removeEventListener('scroll', window.scrollEventListener);
        window.scrollEventListener = null;
      }
    };
  }, []);

  const intl = useIntl();

  const layoutAreas = `
    topbar
    main
    footer
  `;

  const params = useParams();
  const lang = params?.lang;
  // Recursive function to process nested data
  function parseNestedData(termData, level = 0) {
    const elements = [];

    if (Array.isArray(termData)) {
      termData.forEach((element, index) => {
        elements.push(...parseNestedData(element, level));
      });
    } else if (typeof termData === 'object' && termData !== null) {
      if (termData.list) {
        elements.push(
          <div key={`list-${level}`} style={{ paddingLeft: `${level * 20}px` }}>
            <p dangerouslySetInnerHTML={{ __html: termData.value }} />
          </div>
        );
        elements.push(...parseNestedData(termData.list, level + 1));
      } else {
        if (termData.value) {
          elements.push(
            <div key={`object-${level}`} style={{ paddingLeft: `${level * 20}px` }}>
              <p dangerouslySetInnerHTML={{ __html: termData.value }} />
            </div>
          );
        }
      }
    } else if (typeof termData === 'string') {
      elements.push(
        <p key={`string-${level}`} style={{ paddingLeft: `${level * 20}px` }}>
          {termData}
        </p>
      );
    }

    return elements;
  }

  // React component to render the processed data
  const NestedDataDisplay = ({ data }) => {
    const elements = parseNestedData(data);

    return <div>{elements}</div>;
  };
  return (
    <StaticPage>
      <LayoutComposer areas={layoutAreas} className={css.layout}>
        {props => {
          const { Topbar, Main, Footer } = props;
          return (
            <>
              <Topbar as="header">
                <TopbarContainer
                  className={css.topbar}
                  desktopClassName={!showNav ? css.topbarDesktop : null}
                  hideSearchForm
                />
              </Topbar>

              <main className={css.main}>
                <NestedDataDisplay data={data} />
              </main>
              <Footer as="footer">
                <FooterComponent />
              </Footer>
            </>
          );
        }}
      </LayoutComposer>
      <CookieMananger />
    </StaticPage>
  );
};

CusstonTermsOfServicePage.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { currentPageResultIds, queryInProgress, queryPopularError } = state.LandingPage;
  const mostPopularListings = getListingsById(state, currentPageResultIds);
  const { currentUser } = state.user;
  return {
    mostPopularListings,
    queryInProgress,
    queryPopularError,
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateFavorites: payload => dispatch(updateProfile(payload)),
});

const FAQsPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(CusstonTermsOfServicePage);

export default FAQsPage;
